<template>
    <div class="box-wrap reveal-bottom" @click="go(id)">
        <div class="logo">
            <img class="img" :src="imgUrl" alt="img" />
        </div>
        <div class="title">
            {{ title }}
        </div>
        <div class="subTitle" v-ellipsis>
            {{ subTitle }}
        </div>
        <div class="detail">
            DETAIL
            <img
                class="next"
                :src="require('@/assets/img_svg/next.svg')"
                alt="svg"
            />
        </div>
    </div>
</template>
<script>
export default {
    props: {
        imgUrl: String,
        title: String,
        subTitle: String,
        onClick: Function,
        id: String | Number,
    },
    methods: {
        go: function(id) {
            this.$router.push({ path: `/CustomerDetail/${id}` });
        },
    },
};
</script>
<style scoped>
.box-wrap {
    width: 373px;
    height: 398px;
    background: #f8f8f8;
    margin-top: 27px;
    padding-left: 30px;
    padding-right: 30px;
    box-sizing: border-box;
    cursor: pointer;
}
.logo {
    height: 140px;
    display: table-cell;
    vertical-align: middle;
}
.img {
    height: 60px;
}
.title {
    font-size: 18px;
    color: #000000;
    line-height: 22px;
    height: 44px;
}
.subTitle {
    font-size: 14px;
    color: rgba(0, 0, 0, 0.8);
    line-height: 24px;
    margin-top: 10px;
    margin-bottom: 19px;
    height: 116px;
}
.detail {
    height: 67px;
    border-top: 1px solid #000;
    font-size: 18px;
    color: #000000;
    line-height: 67px;
}
.next {
    width: 16px;
    height: 16px;
    float: right;
    margin-top: 24px;
    cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/Pages/Customer/Item.vue